import { discordIcon } from '@swtorbit/shared-assets';
import { useDiscordContext } from '../contexts/DiscordContext';

interface DiscordStatusWidgetProps {
  onOpenDiscordModal: () => void;
}

export function DiscordStatusWidget({ onOpenDiscordModal }: DiscordStatusWidgetProps) {
  const { isLinked, discordUser } = useDiscordContext();

  return (
    <button
      className={`btn btn--outline btn--discord${isLinked ? ' bg-discord bg-o-20' : ''}`}
      onClick={onOpenDiscordModal}
    >
      <img src={discordIcon} alt="Discord" className="icon icon--xl" />
      <span className={`dot ${isLinked ? 'dot--green' : 'dot--slate'}`} />
      <span className={`fs-sm ${isLinked ? 'text-white' : 'text-grey-light'}`}>
        {isLinked ? (discordUser?.username ?? 'Connected') : 'Not connected'}
      </span>
    </button>
  );
}
